import React, { Component } from 'react';
import {InputText} from 'primereact/inputtext';
import { connect } from 'react-redux';
import {Dropdown} from 'primereact/dropdown';
import {InputSwitch} from 'primereact/inputswitch';
import {Toast} from 'primereact/toast';
import {MultiSelect} from 'primereact/multiselect';
import Messages from '../../../shared/UI/Messages/Messages';
import axios from '../../../axios-url';
import ragImage from '../../../assets/images/ragValues.png'


import { REDIRECT_TO_URL, HASACCESS } from '../../../shared/utility';
import { DROPDOWN_CONFIG, KPI_SUBMENU_ID} from '../../../shared/Config';
import FooterButton from '../../../shared/UI/FooterButton/FooterButton';
import * as actions from '../../../store/actions/index';
import { Accordion, AccordionTab } from 'primereact/accordion';


class AddKpi extends Component {
    constructor(props){
        super(props);
        this.state = {
            kpiDescription: '',
            kpiName: '',
            type: "ADD",
            kpiInterOptions: [
                {label: "Daily", value:"0"},
                {label: "Weekly", value:"1"},
                {label: "Monthly", value:"2"},
                {label: "Quarterly", value:"3"},
                {label: "Yearly", value:"4"}
            ],
            kpiFormatOptions: [
                {label: "1,234.56", value:"1,234.56"},
                {label: "1,234", value:"1,234"},
                {label: "12%", value:"12%"},
                {label: "12.34%", value:"12.34%"},
                {label: "$1,234.56", value:"$1,234.56"},
                {label: "12%", value:"12%"},
                {label: "12.34%", value:"12.34%"} ,               
                {label: "12 secs", value:"12 secs"},
                {label: "12 mins", value:"12 mins"},
                {label: "12 hrs", value:"12 hrs"},
                {label: "12 days", value:"12 days"},                
                {label: "12 wks", value:"12 wks"},
                {label: "12 mths", value:"12 mths"},
                {label: "12 qtrs", value:"12 qtrs"},
                {label: "12 yrs", value:"12 yrs"}                     
            ],
            kpiCategoryOptions: [
                {label: "HSE", value:"HSE"},
                {label: "HR", value:"HR"},
                {label: "Finance", value:"Finance"},
                {label: "Procurement", value:"Procurement"},
                {label: "Sales", value:"Sales"}
            ],
            kpiDirectionOptions: [
                {label: "Up", value:"Up"},
                {label: "Done", value:"Done"},
                {label: "None", value:"None"},
            ],  
            kpiAggregateOptions: [
                {label: "Sum", value:"Sum"},
                {label: "Average", value:"Average"},
            ],  
            kpiIsCalculatedOptions: [
                {label: "Yes", value:"Yes"},
                {label: "No", value:"No"},
            ],                                              
        };
    }

    componentDidMount(){
        
        this.props.getMasterTableList('Employee/GetKpi');
        console.log("testfetchkpibefore")
        console.log(this.props)
        this.getAccess = HASACCESS(KPI_SUBMENU_ID);
        console.log("testfetchkpiafter")

        //this.props.fetchKpiList();
        let type = this.props.match.params.type;
        if(type !== 'add'){
            this.setState({loading:true});
            setTimeout(()=>{
                this.fetchSingleProcess();
                this.setState({loading:false});
            },3000)
          
        }
    }

    fetchSingleProcess = () =>{

        let id = this.props.match.params.id;   
        let type = this.props.match.params.type;
        let storageItems = [];

        console.log("test")
        if(this.props.tableLists !== undefined){
            console.log("test2")
            storageItems = this.props.tableLists;
            
        }

        if(storageItems){
            console.log("test3")
            let filterData = storageItems.filter(list => {
                return list.kpiId === id;
            }).reduce((arr,el) => {
                return el;
            },{});
            if(filterData){
                console.log(filterData.id)
                console.log("filterData.id")
                var data = {
                    type:type,
                    Id:filterData.id,
                    kpiId:filterData.kpiId,
                    kpiNo : filterData.kpiNo,
                    kpiName : filterData.kpiName,
                    kpiUnit : filterData.kpiUnit,
                    description : filterData.description,
                    category : filterData.category,
                    interval : filterData.interval,
                    format : filterData.format,
                    aggregate : filterData.aggregate,
                    calculated : filterData.calculated,
                    formula : filterData.formula,
                    targetcalculated : filterData.targetcalculated,
                    rag1 : filterData.rag1,
                    rag2 : filterData.rag2,
                    rag3 : filterData.rag3,
                    rag4 : filterData.rag4,
                    createdby : filterData.createdby,
                    createddate : filterData.createddate,
                    updatedby : filterData.updatedby,
                    updateddate : filterData.updateddate                                                               
                }

                this.setState(data);
                
            }
        }

    }

    change = (e) => {
        let {name, value} = e.target;
        this.setState({[name]:value,touch:true})
        
    }

    add = () => {
        
        if(this.state.kpiNo === ""){
           this.growl.show({severity: 'error', summary: null, detail: 'KPI no is required'});
           return;
        }else if(this.state.kpiName === ""){
           this.growl.show({severity: 'error', summary: null, detail: 'KPI name is required'});
           return;
        }else if(this.state.category === null){
           this.growl.show({severity: 'error', summary: null, detail: 'KPI Category is required'});
           return;
       }else if(this.state.interval === null){
           this.growl.show({severity: 'error', summary: null, detail: 'KPI Interval is required'});
           return;
       }


       var data = {
        type : this.state.type,
        Id : this.state.id,
        kpiId:this.state.kpiId,
        kpiNo : this.state.kpiNo,
        kpiName : this.state.kpiName,
        kpiUnit : this.state.kpiUnit,
        description : this.state.description,
        category : this.state.category,
        interval : this.state.interval,
        format : this.state.format,
        aggregate : this.state.aggregate,
        calculated : this.state.calculated,
        formula : this.state.formula,
        targetcalculated : this.state.targetcalculated,
        rag1 : this.state.rag1,
        rag2 : this.state.rag2,
        rag3 : this.state.rag3,
        rag4 : this.state.rag4,
        createdby : this.state.createdby,
        createddate : this.state.createddate,
        updatedby : this.state.updatedby,
        updateddate : this.state.updateddate 

       }
      
       if(this.state.type === 'add'){
           data.Createdby = this.state.createdBy;
           data.Createddate = this.state.createdDate;
       }

       if(this.state.type === 'edit'){
           data.PositionId = this.state.PositionId;
           data.Id = this.state.Id;
           data.Updatedby = (this.props.loggedUserDetail.userName) ?? 'Admin';
           data.Updateddate = new Date();
       }

       this.props.processDynamicData('Kpi',this.state.type,data,'Kpi');

   }

   resetData = () => {
       var data = {
           PositionNo : '',
           //JobId : this.state.JobId,
           ReportedTo : null,
           Name : '',
           Description : '',
       }
       this.setState(data);
   }


    render(){
        if(this.props.success){
            REDIRECT_TO_URL('/KPI-Master/',this.props);
        }


        let addAccess = true;
        let editAccess = true;
        if(this.getAccess!==undefined){
            if(this.getAccess.viewAccess === false && this.props.userDetail.userId!==this.props.match.params.id){this.props.history.push('/dashboard')}
            addAccess = (this.getAccess.addAccess === true) ? true : false;
            editAccess = (this.getAccess.editAccess === true) ? true : false;
        }
        let accessButton = { addAccess : addAccess, editAccess : editAccess}
        
        let isEnabled = (this.state.touch === true);

        let redirectURL = '/KPI-Master/';
        if(this.props.tableLists && this.props.match.params.id!==undefined){
            if(this.props.tableLists.kpiId=== this.props.match.params.id){
                redirectURL = "/dashboard";
            }
        }

        // const rgbIm = require('../../assets/images/ragValues.png');
        return(
            <div className="p-grid">
            { this.props.loading && <div className="page-loader"></div>}
            { this.props.error !== null && <Messages type="error" message={this.props.error}/>}
            { this.props.success !== null && <Messages type="success" message={this.props.success}/>}
            <Toast ref={(el) => this.growl = el} />
            <div className="p-col-12">
                <div className="card card-w-title" style={{position:'relative'}}>
                    <h1>{this.state.type} KPI</h1>
                    <div className="p-grid mt1">
                           
                           <div className="p-col-6 p-offset-3">

                               <div className="p-col-12">
                                   <label htmlFor="acSimple">KPI No <span className="requiredColor">*</span> :</label>
                               </div>
                               <div className="p-col-12 ">
                               <InputText className="p-col-12" name="kpiNo" placeholder="KPI Number" value={this.state.kpiNo} onChange={this.change}/>
                               </div>	

                               <div className="p-col-12">
                                   <label htmlFor="acSimple">Add a description <span className="requiredColor">*</span> :</label>
                               </div>
                               <div className="p-col-12 ">
                               <InputText className="p-col-12" name="kpiName" placeholder="KPI Name" value={this.state.kpiName} onChange={this.change}/>
                               </div>	



                                <div className="p-grid p-col-12">
                                    <div className="p-col-6">
                                        <div className="p-col-12">
                                            <label >When will this KPI be entered <span className="requiredColor">*</span> :</label>
                                        </div>
                                        <div className="p-col-12">
                                        <Dropdown className="p-col-12" name="interval" placeholder="When will this KPI be entered" options={this.state.kpiInterOptions} value={this.state.interval} onChange={this.change} {...DROPDOWN_CONFIG}/>
                                        </div>	
                                    </div>

                                    <div className="p-col-6">
                                        <div className="p-col-12">
                                            <label >Format Of KPI<span className="requiredColor">*</span> :</label>
                                        </div>
                                        <div className="p-col-12">
                                        <Dropdown className="p-col-12" name="format" placeholder="Format Of KPI" options={this.state.kpiFormatOptions} value={this.state.format} onChange={this.change} {...DROPDOWN_CONFIG}/>
                                        </div>	
                                    </div>
                                </div>

                                <div className="p-col-12">
                                   <label htmlFor="acSimple">Does the KPI have a target? <span className="requiredColor">*</span> :</label>
                               </div>
                               <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="kpiTarget" placeholder="KPI Target" value={this.state.kpiTarget} onChange={this.change}/>
                               </div>	

                               <div className="p-col-12">
                                <Accordion >
                                    <AccordionTab header="Show advanced Options">
                                    <div className="p-col-12">
                                        <div className="p-col-12">
                                            <label >Which category ?<span className="requiredColor">*</span> :</label>
                                        </div>
                                        <div className="p-col-12">
                                        <Dropdown className="p-col-12" name="category" placeholder="KPI Category" options={this.state.kpiCategoryOptions} value={this.state.category} onChange={this.change} {...DROPDOWN_CONFIG}/>
                                        </div>	
                                    </div>

                                    <div className="p-col-12">
                                        <div className="p-col-12">
                                            <label >Which direction is best ?<span className="requiredColor">*</span> :</label>
                                        </div>
                                        <div className="p-col-12">
                                        <Dropdown className="p-col-12" name="direction" placeholder="KPI Direction" options={this.state.kpiDirection} value={this.state.Direction} onChange={this.change} {...DROPDOWN_CONFIG}/>
                                        </div>	
                                    </div>

                                    <div className="p-col-12">
                                        <div className="p-col-12">
                                            <label >How is the KPI aggregated? <span className="requiredColor">*</span> :</label>
                                        </div>
                                        <div className="p-col-12">
                                        <Dropdown className="p-col-12" name="aggregate" placeholder="How is the KPI aggregated?" options={this.state.kpiAggregateOptions} value={this.state.aggregate} onChange={this.change} {...DROPDOWN_CONFIG}/>
                                        </div>	
                                    </div>

                                    <div className="p-col-12">
                                        <div className="p-col-12">
                                            <label >Is this a calculated KPI ? <span className="requiredColor">*</span> :</label>
                                        </div>
                                        <div className="p-col-12">
                                        <Dropdown className="p-col-12" name="calculated" placeholder="Is this a calculated KPI ?" options={this.state.kpiIsCalculatedOptions} value={this.state.calculated} onChange={this.change} {...DROPDOWN_CONFIG}/>
                                        </div>	
                                    </div>

                                    <div className="p-col-12">
                                        <div className="p-col-12">
                                            <label >Is the target calculated ? <span className="requiredColor">*</span> :</label>
                                        </div>
                                        <div className="p-col-12">
                                            <Dropdown className="p-col-12" name="calculated" placeholder="Is the target calculated ?" options={this.state.kpiIsCalculatedOptions} value={this.state.calculated} onChange={this.change} {...DROPDOWN_CONFIG}/>
                                        </div>	
                                    </div>

                                    <div className="p-grid p-col-12">
                                        <div className="p-col-12">
                                            <label >What are the RAG Thresholds?<span className="requiredColor">*</span> :</label>
                                        </div>
                                        {/* <img src="../../../assets/images/ragValues" /> */}

                                        <img src={ragImage} className="p-col-12" alt="logofooter" width="80"/>

                                        <div className="p-col-3">
                                            <InputText className="p-col-12" name="rag1" placeholder="KPI Thresholds" value={this.state.rag1} onChange={this.change}/>
                                        </div>	
                                        <div className="p-col-3">
                                            <InputText className="p-col-12" name="rag2" placeholder="KPI Thresholds" value={this.state.rag2} onChange={this.change}/>
                                        </div>	
                                        <div className="p-col-3">
                                            <InputText className="p-col-12" name="rag3" placeholder="KPI Thresholds" value={this.state.rag3} onChange={this.change}/>
                                        </div>	
                                        <div className="p-col-3">
                                            <InputText className="p-col-12" name="rag4" placeholder="KPI Thresholds" value={this.state.rag4} onChange={this.change}/>
                                        </div>	
                                    </div>

                                    <div className="p-grid p-col-12">
                                        <div className="p-col-4">
                                            <label>What is your working week ? <span className="requiredColor">*</span> :</label>
                                        </div>

                                        <Dropdown className="p-col-8" name="category" placeholder="KPI Description" options={this.state.kpiCategoryOptions} value={this.state.category} onChange={this.change} {...DROPDOWN_CONFIG}/>
                                    </div>

                                    </AccordionTab>
                                </Accordion>
                               </div>
                                {/* 
                                <div className="p-col-12">
                                    <label className="p-col-4">Give your KPI a name <span className="requiredColor">*</span> :</label>
                                    <InputText className="p-col-7" placeholder="Enter A Description"  value={this.state.KpiName} name="KpiName" onChange={this.change} {...DROPDOWN_CONFIG} />
                                </div>	

                                <div className="p-col-12">
                                    <label className="p-col-4">Add a description (optional)</label>
                                    <InputText className="p-col-7" placeholder="Enter A Description"  value={this.state.KpiDescription} name="KpiDescription" onChange={this.change} {...DROPDOWN_CONFIG} />
                                </div>	 */}

                        </div>
                        <div className="p-col-12 p-lg-12">

                        <FooterButton access={accessButton} disabled={!isEnabled} type={this.state.type.toLowerCase()} save={this.add} reset={this.resetData}  to={redirectURL} />

                        </div>
                    </div>
                </div>
            </div>

        </div>)
    }
}

const mapStateToProps = state => {
    return{
        loggedUserDetail : state.auth.userObject,
        loading : state.master.loading,
        error : state.master.error,
        success: state.master.success,
        positionList : state.master.positionList,
        tableLists : state.master.tableLists,
        relationType : (state.keyword.relationType!==undefined) ? state.keyword.relationType : [],
        TimeoffType: (state.keyword.TimeoffType!==undefined) ? state.keyword.TimeoffType : [],
        employeeGroup: (state.keyword.employeeGroup!==undefined) ? state.keyword.employeeGroup : [],
        Department: (state.keyword.Department!==undefined) ? state.keyword.Department : [],
        Division: (state.keyword.Division!==undefined) ? state.keyword.Division : [],
        Section: (state.keyword.Section!==undefined) ? state.keyword.Section : [],
        UnCategorized: (state.keyword.UnCategorized!==undefined) ? state.keyword.UnCategorized : [],
        VicePresident: (state.keyword.VicePresident!==undefined) ? state.keyword.VicePresident : [],
        Executive: (state.keyword.Executive!==undefined) ? state.keyword.Executive : [],
        
    }
}
  
const mapDispatchToProps = dispatch => {
    return{
        fetchPositionLists : () => dispatch(actions.fetchPositionLists()),
        getMasterKeywordList : (value) => dispatch(actions.getMasterKeywordList(value)),
        processDynamicData: (model,type,data,func) => dispatch(actions.processDynamicData(model,type,data,func)),
        getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddKpi);